import { ContentListItem } from 'interfaces'
import dayjs from 'lib/dayjs'

export const canBeEdited = (data: ContentListItem): boolean => {
	switch (data?.status) {
		case 'finished':
			return false
		case 'published':
			return false
		case 'processing':
			return data?.release_date
				? dayjs.utc(data?.release_date).local().isAfter(dayjs())
				: true
		case 'draft':
			return true
		default:
			return true
	}
}
